// extracted by mini-css-extract-plugin
export default {"base":"base-IVLFS","link":"link-ZrIsy"};